<template>
  <div class="analysis">
    <div class="analysis_header">
      <div class="header">
        <span><i class="el-icon-arrow-left" style="cursor: pointer;" @click="goBack()"></i></span>
        <span> 作品数据详情</span>
        <span><i class="el-icon-more"></i></span>
      </div>
      <div class="select_work" v-show="!isFold">
        <div class="show_video">
          <div class="img_box">
            <img :src="video_obj.img" alt="">
            <span class="time"><i class="el-icon-caret-right"></i></span>
          </div>
          <div class="video_info">
            <div class="title">{{ video_obj.title}}</div>
            <div class="time">{{ video_obj.release_time }} 发布 | 部分数据次日更新</div>
          </div>
        </div>
      </div>
      <div class="select_work_button" v-show="!isFold" @click="showWorkList()">切换作品 <i class="el-icon-arrow-down"></i></div>
      <div class="home_container_header">
        <div :class="['tab_list',{'active_tab_list':activeTabIndex==item.id}]" v-for="item in tabList" :key="item.id" @click="activeTab(item.id)">{{ item.name }}</div>
      </div>
    </div>
    <div class="container" @scroll="handleScroll">

      <AllView v-if="activeTabIndex==1" />
      <FlowAnalysis v-if="activeTabIndex==2" />
      <AudienceAnalysis :isFold="isFold" v-if="activeTabIndex==3" @scrollTop="screenTop" />

    </div>
  </div>
</template>
    
  <script>
import AllView from "../../../components/training/AllView.vue";
import FlowAnalysis from "../../../components/training/FlowAnalysis.vue";
import AudienceAnalysis from "../../../components/training/AudienceAnalysis.vue";
export default {
  name: "Analysis",
  data() {
    return {
      tabList: [
        {
          name: "总览",
          id: 1,
        },
        {
          name: "流量分析",
          id: 2,
        },
        {
          name: "观众分析",
          id: 3,
        },
      ],
      videoList: [
        {
          img: require("@/assets/img/image/video_image0.jpeg"),
          video_url: "",
          videoId: 1,
          title:
            "咱就是说好这一口五彩椒，它不辣甚至有点甜D#女生必看#好吃到停不下来 #彩椒 #抖音美食推荐官 #超好吃",
          release_time: "2025-02-08 21:29",
          play_num: "45.7万",
          like_num: "614",
          review_num: "34",
          share_num: "263",
          video_time: "00:23",
        },
        {
          img: require("@/assets/img/image/video_img1.jpg"),
          video_url: "",
          videoId: 2,
          title:
            "姐妹们他真的夹到我了,可把我乐坏了#ally#做精致女人#男朋友#女生必备 #分享生活",
          release_time: "2025-02-08 21:29",
          play_num: "3.7万",
          like_num: "205",
          review_num: "4",
          share_num: "100",
          video_time: "00:44",
        },
      ],
      activeTabIndex: 1,
      video_obj: {},
      isFold: false,
    };
  },
  components: {
    AllView,
    FlowAnalysis,
    AudienceAnalysis,
  },
  created() {
    this.video_obj = this.videoList[this.$route.query.video_id - 1];
  },
  computed: {},

  methods: {
    activeTab(id) {
      this.activeTabIndex = id;
      const container=document.getElementsByClassName("container")[1]
      if (container) {
        container.scrollTop = 0;
      }
    },
    showWorkList() {},
    goBack() {
      this.$router.go(-1);
    },
    handleScroll(event) {
      const scrollTop = event.target.scrollTop;
      this.isFold = scrollTop > 0 ? true : false;
    },
    screenTop(){
      const container=document.getElementsByClassName("container")[1]
      if (container) {
        container.scrollTop = 0;
      }
    }
  },
};
</script>
    
    <style lang="scss" scoped>
.analysis {
  width: 100%;
  background: #f3f3f4;
  .analysis_header {
    width: 100%;
    position: fixed;
    top: -1px;
    left: 0;
    z-index: 10000;
    background: #f3f3f4;
    .header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      height: 46px;
      align-items: center;
      padding: 0 20px;
      font-size: 18px;
      font-weight: 600;
      box-sizing: border-box;
    }
    .select_work {
      padding: 0 15px;
      .show_video {
        display: flex;
        .img_box {
          flex-shrink: 0;
          width: 70px;
          height: 90px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
          }
          .time {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
            font-size: 30px;
          }
        }
        .video_info {
          flex: 1;
          width: 0;
          height: 90px;
          margin-left: 10px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          // justify-content: space-between;
          .title {
            width: 100%;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1; /* 显示的行数 */
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 15px;
            font-weight: 600;
            letter-spacing: 1px;
          }
          .time {
            margin-top: 10px;
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
    .select_work_button {
      padding: 10px 15px;
      color: #666;
      cursor: pointer;
    }
    .home_container_header {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      //   background: #e9ecf2;
      .tab_list {
        color: #646566;
        font-size: 14px;
        border-bottom: 3px solid transparent;
        padding-bottom: 5px;
        cursor: pointer;
      }
      .active_tab_list {
        color: #323233;
        font-weight: 600;
        border-bottom: 3px solid #577cf7;
        // background: #fff;
      }
    }
  }

  .container {
    width: 100%;
    padding: 0 10px;
    padding-top: 225px;
    overflow-y: auto;
    height: 100%;
    box-sizing: border-box;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}
</style>
    